<template>
<div container--fluid>
    <v-layout>
        <OrderModule orig="hpc"></OrderModule>
    </v-layout>
</div>
</template>

<script>
import OrderModule from '@modules/order/index.vue';

export default {
    name: 'order',
    components: {
        OrderModule,
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
